import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";

import config from '../../../config';

import Ramp from '../../../assets/img/icons/ramp.png';
import Disaster from '../../../assets/img/icons/disaster.png';

class FeedbackImage extends Component {
  static propTypes = {
    image: PropTypes.string,
    desktop: PropTypes.bool,
    descriptionAbsolute: PropTypes.bool,
  };

  static defaultProps = {
    desktop: false,
    descriptionAbsolute: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      showComponent: false
    };
  }

  render() {
    let img = '';
    const { desktop } = this.props;

    if (this.props.image) {
      if (this.props.image.indexOf('.jpg') !== -1) {
        img = this.props.image.slice(0, this.props.image.length - 4);
      } else if (this.props.image.indexOf('.jpeg') !== -1) {
        img = this.props.image.slice(0, this.props.image.length - 5);
      } else {
        img = this.props.image;
      }
    }

    const description = (this.props.description && this.props.description !== '<p>-</p>' && this.props.description !== '<p>- </p>' && this.props.description !== '<p> -</p>' ? this.props.description : false);

    return (
      <div className={'feedback-image-container ' + (this.props.transitionDelay ? this.props.transitionDelay : '') + (description === false ? ' noText' : '')}>
        {img ?
          <div className={'feedback-image'} style={(desktop ? {backgroundImage: `url(${config.mediaUrl}${img}.jpeg)`} : {})}>
            { !desktop ? (
              <img alt={'feedback-img'} src={`${config.mediaUrl}${img}.jpeg`} style={{width: '100%'}}/>
            ) : null }

            {
              this.props.disaster ?
                <img className={'disaster-feedback-image'} alt={'disaster'} src={this.props.gameState.language === "NL" ? Ramp : Disaster}/>
                : null
            }

          </div> : ''
        }
        {
          description ?
            <span className={`imageText ${this.props.forceShowText ? "forceShow" : ""} ${this.props.descriptionAbsolute ? 'imageText--absolute' : ''}`} dangerouslySetInnerHTML={{ __html: this.props.description }}/>
          : null
        }
      </div>
    )

  }
}

export default connect(({ gameState }) => ({ gameState }))(FeedbackImage);



// WEBPACK FOOTER //
// ./src/components/elements/feedback/FeedbackImage.js